import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, ShieldCheck, Clock, Download } from 'lucide-react';
export function PricingSection() {
  const handleCTAClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    // Track AddToCart event
    if (window.fbq) {
      window.fbq('track', 'AddToCart', {
        content_name: 'Quincena Milagrosa',
        content_ids: ['42994498404470'],
        content_type: 'product',
        value: 7.97,
        currency: 'USD'
      });
    }
  };
  return <section className="py-24 bg-[#FFFBEB] relative overflow-hidden" data-id="element-123">
      {/* Background decoration */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none" data-id="element-124">
        <div className="absolute top-1/4 left-0 w-64 h-64 bg-amber-200/30 rounded-full blur-3xl transform -translate-x-1/2" data-id="element-125"></div>
        <div className="absolute bottom-1/4 right-0 w-96 h-96 bg-orange-200/30 rounded-full blur-3xl transform translate-x-1/2" data-id="element-126"></div>
      </div>

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-127">
        {/* Promise */}
        <div className="text-center mb-16" data-id="element-128">
          <h2 className="text-2xl md:text-3xl font-bold text-amber-950 mb-4" data-id="element-129">
            Una afirmación clara y directa:
          </h2>
          <p className="text-xl md:text-2xl text-amber-800 font-medium" data-id="element-130">
            👉 Si aplicas estos 10 hacks y usas los bonos,{' '}
            <br className="hidden md:block" data-id="element-131" />
            <span className="text-amber-600 font-bold bg-amber-100 px-2" data-id="element-132">
              tu sueldo rendirá más desde la próxima quincena.
            </span>
          </p>
          <p className="mt-4 text-amber-900/60" data-id="element-133">
            No en seis meses. No "algún día". Desde la siguiente quincena.
          </p>
        </div>

        {/* Pricing Card */}
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-white rounded-3xl shadow-2xl border border-amber-100 overflow-hidden max-w-2xl mx-auto" data-id="element-134">
          <div className="bg-amber-900 p-6 text-center text-white" data-id="element-135">
            <h3 className="text-2xl font-bold" data-id="element-136">Oferta Especial Limitada</h3>
            <p className="text-amber-200 text-sm mt-1" data-id="element-137">
              Acceso inmediato a todo el contenido
            </p>
          </div>

          <div className="p-8 md:p-12 text-center" data-id="element-138">
            <div className="mb-8" data-id="element-139">
              <p className="text-amber-900/60 mb-2 text-lg" data-id="element-140">
                Precio regular: <span className="line-through" data-id="element-141">$27 USD</span>
              </p>
              <div className="flex items-center justify-center gap-2" data-id="element-142">
                <span className="text-6xl md:text-7xl font-bold text-amber-950 tracking-tight" data-id="element-143">
                  $7.97
                </span>
                <span className="text-xl font-medium text-amber-600 self-end mb-4" data-id="element-144">
                  USD
                </span>
              </div>
              <p className="text-green-600 font-bold mt-2 bg-green-50 inline-block px-3 py-1 rounded-full text-sm" data-id="element-145">
                Pago único · Sin suscripciones
              </p>
            </div>

            <a href="https://almadigitalebooks.digital/cart/42994498404470:1" onClick={handleCTAClick} className="w-full bg-gradient-to-r from-amber-500 to-orange-600 text-white font-bold text-xl py-5 px-8 rounded-xl shadow-xl shadow-amber-500/30 hover:shadow-2xl hover:scale-[1.02] transition-all duration-300 flex items-center justify-center gap-3 group mb-6" data-id="element-146">
              <span data-id="element-147">Descargar Quincena Milagrosa</span>
              <ArrowRight className="w-6 h-6 group-hover:translate-x-1 transition-transform" data-id="element-148" />
            </a>

            <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 text-sm text-amber-800/70 border-t border-amber-100 pt-6" data-id="element-149">
              <div className="flex items-center justify-center gap-2" data-id="element-150">
                <ShieldCheck className="w-4 h-4 text-amber-500" data-id="element-151" />
                <span data-id="element-152">Pago 100% Seguro</span>
              </div>
              <div className="flex items-center justify-center gap-2" data-id="element-153">
                <Download className="w-4 h-4 text-amber-500" data-id="element-154" />
                <span data-id="element-155">Descarga Inmediata</span>
              </div>
              <div className="flex items-center justify-center gap-2" data-id="element-156">
                <Clock className="w-4 h-4 text-amber-500" data-id="element-157" />
                <span data-id="element-158">Acceso de por vida</span>
              </div>
            </div>
          </div>
        </motion.div>

        <div className="mt-12 text-center text-amber-900/70 max-w-2xl mx-auto" data-id="element-159">
          <p className="italic" data-id="element-160">
            "¿Cuánto vale dormir tranquila? ¿Cuánto vale no pelearte con tu
            dinero? ¿Cuánto vale gastar sin culpa? Mucho más de lo que cuesta
            este ebook."
          </p>
        </div>
      </div>
    </section>;
}